import { Button } from "@/components/ui/button";
import { ArrowRight, MessageSquare } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ROUTES } from "@/lib/constants/routes";

const CTASection = () => {
    const { t } = useTranslation();

    return (
        <section className="py-24 relative overflow-hidden animate-fade-up">
            {/* Artistic Background */}
            <div className="absolute inset-0 bg-african-secondary/5 -z-10" />
            <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-african-accent/10 rounded-full blur-3xl" />

            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-stretch mt-8 sm:mt-0">
                    {/* Left side: Instructor Focus */}
                    <div className="bg-african-accent rounded-3xl p-6 sm:p-10 text-white shadow-soft relative overflow-hidden group animate-fade-up h-full">
                        <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:scale-110 transition-transform duration-500">
                            <ArrowRight size={120} className="-rotate-45" />
                        </div>

                        <div className="relative z-10 flex flex-col h-full justify-between gap-8">
                            <div>
                                <span className="inline-block px-4 py-2 bg-black/10 backdrop-blur-md rounded-full text-sm font-bold mb-6 border border-white/10">
                                    {t('landing.cta.instructor.badge')}
                                </span>
                                <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6 leading-tight">
                                    {t('landing.cta.instructor.title')}
                                </h2>
                                <p className="text-lg text-white italic">
                                    "{t('landing.cta.instructor.subtitle')}"
                                </p>
                            </div>

                            <div className="space-y-6">
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <Button asChild className="bg-white text-african-accent hover:bg-white/90 h-12 px-6 rounded-xl font-bold text-base w-full sm:w-auto">
                                        <Link to={`${ROUTES.REGISTER}`}>
                                            {t('landing.cta.instructor.button')}
                                        </Link>
                                    </Button>
                                    <Button variant="outline" className="border-white/30 text-white hover:bg-white/10 h-12 px-6 rounded-xl font-bold text-base w-full sm:w-auto">
                                        <MessageSquare className="mr-2" size={18} />
                                        {t('landing.cta.instructor.advisor')}
                                    </Button>
                                </div>

                                <p className="text-xs text-white/90">
                                    {t('landing.cta.instructor.note')}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Right side: Student Focus */}
                    <div className="bg-background border border-border rounded-3xl p-6 sm:p-10 shadow-soft animate-fade-up flex flex-col justify-between items-start gap-8 h-full" style={{ animationDelay: '0.2s' }}>
                        <div>
                            <span className="inline-block px-4 py-2 bg-african-secondary/20 text-african-accent rounded-full text-sm font-bold mb-6">
                                {t('landing.cta.student.badge')}
                            </span>
                            <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6">
                                {t('landing.cta.student.title')}
                            </h2>
                            <p className="text-lg text-muted-foreground leading-relaxed">
                                {t('landing.cta.student.subtitle')}
                            </p>
                        </div>
                        <Button asChild className="bg-african-accent hover:bg-african-accent/90 text-white h-12 px-6 rounded-xl font-bold text-base shadow-African w-full sm:w-auto">
                            <Link to={`${ROUTES.REGISTER}`}>
                                {t('landing.hero.cta')}
                                <ArrowRight className="ml-2" size={18} />
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
